import {Controller} from 'stimulus'
import $ from 'jquery'

export default class extends Controller {
  disable () {
    this.element.style.pointerEvents = 'none'
    this.element.innerHTML = $(this.element).data('disable-label')
  }
}
